import * as React from "react";
import ReactGA from "react-ga4";

export interface SocialLinkProps {
  href: string;
  icon: React.ReactNode;
  label?: string;
  variant?: "default" | "compact";
}

export const SocialLink = ({ href, icon, label, variant = "default" }: SocialLinkProps) => {
  const handleClick = () => {
    ReactGA.event({ category: "Contact", action: "Click Social Link", label: label ?? href });
  };

  return (
    <a
      href={href}
      target={href.startsWith("mailto:") ? undefined : "_blank"}
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label={label ?? href}
      className={`inline-flex items-center justify-center rounded-sm border border-border bg-surface text-primary hover:border-border-accent hover:bg-accent-bg hover:text-accent ${
        variant === "compact" ? "size-8" : "size-9"
      }`}
    >
      {icon}
    </a>
  );
};
